"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const KeyStrokeFactory_1 = require("../../DOM/EventTarget/KeyStrokeFactory");
class EventFilter {
    /**
     * Only invoke the given listener if the key modifier match the events
     *
     * @param modifiers string of event modifiers. Example: `ctrl+alt+shift`
     * @param listener the event listener to invoke when the key modifiers are present
     */
    static filterModifierEvent(modifiers, listener) {
        const keyStroke = KeyStrokeFactory_1.default.fromString(modifiers);
        return (event) => {
            if (keyStroke.ctrl === event.ctrlKey
                && keyStroke.alt === event.altKey
                && keyStroke.shift === event.shiftKey) {
                // invoke listener only, and absolutely only when all modifiers match the event modifiers
                listener(event);
            }
        };
    }
}
exports.default = EventFilter;
//# sourceMappingURL=EventFilter.js.map